import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class ReportingOfaService {
  private data: any;
  private subjectAnalyse = new Subject<void>();
  private historiqueSubject = new BehaviorSubject<any[]>([]);
  historique$ = this.historiqueSubject.asObservable();

  constructor(private http: HttpClient) {
  }

  setHistorique(historique: any[]) {
    this.historiqueSubject.next(historique);
  }

  setData( data: any) {
    this.data = data;
    localStorage.setItem('niveaux', JSON.stringify(data))
  }

  getData() {
    const data =  localStorage.getItem('niveaux')
    return JSON.parse(data);
  }

  refreshDataAnalyse$ = this.subjectAnalyse.asObservable();


}
